// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import { initializeApp } from "firebase/app";
import {
  ReCaptchaEnterpriseProvider,
  getToken,
  initializeAppCheck
} from "firebase/app-check";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBkm-kfHLKQ1ZsMm0d7x-CNI6tSaSLfKbw",
  authDomain: "oss-shop-demo.firebaseapp.com",
  projectId: "oss-shop-demo",
  storageBucket: "oss-shop-demo.firebasestorage.app",
  messagingSenderId: "840079836046",
  appId: "1:840079836046:web:bf13d892d90ac8b0505adf",
  measurementId: "G-E72W7098K7"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;
let appCheckInstance = null;

if (
  process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN &&
  typeof window !== "undefined"
) {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN =
    process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;
}

function getAppCheck() {
  if (!appCheckSiteKey) return null;
  if (appCheckInstance) return appCheckInstance;

  appCheckInstance = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true
    });

  return appCheckInstance;
}

export const auth = getAuth(app);
export const authPersistenceReady = setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error(error);
});
export const db = getFirestore(app);
export const storage = getStorage(app);

export async function getAppCheckHeaders() {
  const appCheck = getAppCheck();

  if (!appCheck) return {};

  try {
    const token = await getToken(appCheck);

    return token?.token ? { "X-Firebase-AppCheck": token.token } : {};
  } catch (error) {
    console.error(error);
    return {};
  }
}
